import axios from "axios";
import routes from "../../configs/api";
import getCouponAuthHeaders from "./couponAuthHeaders";

const updateCoupon = (id, payload) => {
  return new Promise((resolve, reject) => {
    let headers;

    try {
      headers = getCouponAuthHeaders();
    } catch (error) {
      reject(error);
      return;
    }

    axios
      .put(`${routes.UPDATE_COUPON}/${id}`, payload, {
        headers,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export default updateCoupon;
